export default __webpack_public_path__ + "low_coverage_ses_bc.png";